import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca4fcca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-test": "property-modal",
  class: "flex flex-col overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center h-modal md:h-full md:inset-0 bg-opacity-50 bg-gray-500",
  style: {"z-index":"1200"}
}
const _hoisted_2 = { class: "bg-white w-1/3 my-4 p-4 rounded" }
const _hoisted_3 = { class: "border-2 border-black" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-yellow-300 border-b-2 border-black p-3 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-large capitalize antialiased text-xl font-bold text-black mt-0 roboto-font" }, " OFFER A DEAL ")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "p-3 text-black"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex justify-between space-x-5" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = { class: "w-full capitalize" }
const _hoisted_12 = {
  key: 0,
  class: "flex justify-between w-1/4"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "money", -1))
const _hoisted_14 = { class: "text-green-600" }
const _hoisted_15 = {
  key: 1,
  class: "flex justify-between w-1/4"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "money", -1))
const _hoisted_17 = { class: "text-red-600" }
const _hoisted_18 = { class: "my-4" }
const _hoisted_19 = ["min", "max"]
const _hoisted_20 = { class: "bg-white p-3 text-center" }
const _hoisted_21 = { class: "flex justify-between my-2" }
const _hoisted_22 = {
  "data-test": "ok-modal-button",
  ref: "ok",
  class: "px-5 py-2 bg-green-600 roboto-font text-white rounded drop-shadow-md font-medium tracking-wider hover:bg-green-700 hover:drop-shadow-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayerCard = _resolveComponent("PlayerCard")!
  const _component_Icon = _resolveComponent("Icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.state.player)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_PlayerCard, {
                      name: _ctx.Players.getCurrentPlayer.name,
                      id: _ctx.Players.getCurrentPlayer.id,
                      amount: _ctx.Players.getCurrentPlayer.bankBalance,
                      image: _ctx.Players.getCurrentPlayer.link
                    }, null, 8, ["name", "id", "amount", "image"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_PlayerCard, {
                      name: _ctx.state.player.name,
                      id: _ctx.state.player.id,
                      amount: _ctx.state.player.bankBalance,
                      image: _ctx.state.player.link
                    }, null, 8, ["name", "id", "amount", "image"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex justify-between", [_ctx.state.value > 0 ? 'flex-row-reverse' : 'flex-row']])
                    }, [
                      (_ctx.state.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_Icon, {
                                class: "text-green-500",
                                style: {"font-size":"40px"},
                                icon: "ph:arrow-fat-left-fill"
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_13,
                              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.state.value), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.value < 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", null, [
                              _hoisted_16,
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.state.value), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_Icon, {
                                class: "text-red-500",
                                style: {"font-size":"40px"},
                                icon: "ph:arrow-fat-right-fill"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.value) = $event)),
                    type: "range",
                    min: Number(-_ctx.Players.getCurrentPlayer.bankBalance),
                    step: "100",
                    max: _ctx.Players.getCurrentPlayer.bankBalance,
                    class: "w-full h-3 bg-blue-500 appearance-none rounded"
                  }, null, 8, _hoisted_19), [
                    [_vModelText, _ctx.state.value]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.showModal = false)),
              "data-test": "cancel-modal-button",
              ref: "cancel",
              class: "px-5 py-2 bg-rose-600 roboto-font rounded text-white drop-shadow-md font-medium tracking-wider hover:bg-red-700 hover:drop-shadow-lg"
            }, " Cancel ", 512),
            _createElementVNode("button", _hoisted_22, " Make Offer ", 512)
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.state.showModal]
  ])
}